<template>
    <div>Loading...</div>
</template>

<script>
const Loading = {

};
export default Loading;
</script>